/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Reference to a vehicle, which has the role *insured vehicle*.   (german: versichertes Fahrzeug)   (bipro-Kraftfahrt::VersichertesFahrzeug)
 */
export interface InsuredVehicleRef {
  insuredObjectId?: string;
}
